import isEqual from 'lodash/isEqual';
import isFunction from 'lodash/isFunction';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as Actions from '../../actions';

// Works like connect, but also takes two extra arguments:
// 1) getIdsToCheck: a function that returns an iterable of unique identifiers. We
// will see any time this list changes and go check if we have all the data at that point.
// 2) idVerifier: a function that will take (state, id) as args
// and return a falsy value if the id shouldn't be considered present
// 3) idFetcher: an action creator which will take the state and any ids that need to be fetched as an argument
// the return value of this function will be dispatched.
//
export default function connectAndAddAnnotator(
  originalMapState,
  originalActions = {},
  { getIdsToCheck = noop, idVerifier = noop, idFetcher = noop },
) {
  const fullDataChecker = Actions.Annotations.ensureFullDataActionCreator(idVerifier, idFetcher);
  const annotatorActions = {
    annotatorFullDataChecker: fullDataChecker,
  };

  let newMapDispatch;
  if (isFunction(originalActions)) {
    const annotatorActionFunction = dispatch => {
      return bindActionCreators(annotatorActions, dispatch);
    };
    newMapDispatch = dispatch => {
      return Object.assign(originalActions(dispatch), annotatorActionFunction(dispatch));
    };
  } else {
    newMapDispatch = Object.assign(originalActions, annotatorActions);
  }

  const newMapState = (state, ownProps) => {
    return Object.assign(originalMapState(state, ownProps), {
      annotatorIds: getIdsToCheck(state),
    });
  };

  return ComposedComponent => {
    return connect(
      newMapState,
      newMapDispatch,
    )(
      class extends React.Component {
        static propTypes = {
          // Immutable list or array
          annotatorIds: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
          annotatorFullDataChecker: PropTypes.func,
        };

        componentWillMount() {
          this.props.annotatorFullDataChecker(this.props.annotatorIds);
        }

        componentWillReceiveProps(nextProps) {
          if (nextProps.annotatorIds !== this.props.annotatorIds) {
            if (!isEqual(nextProps.annotatorIds, this.props.annotatorIds)) {
              this.props.annotatorFullDataChecker(nextProps.annotatorIds);
            }
          }
        }

        // We don't want to return annotatorIds because they are not needed and
        // they can trigger a rerender if they are an un-memoized Immutable
        getProps = () => {
          const { ...restProps } = this.props;
          return restProps;
        };

        render() {
          const props = this.getProps();
          return <ComposedComponent {...props} />;
        }
      },
    );
  };
}
